import React from 'react';

import { Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { useGetDetailsQuery } from '@epi-api/user';
import {
  benefitGroupsUrlPrefix,
  routerPaths
} from '@epi-constants/routerPaths';

import StepperStep from './components/StepperStep/StepperStep';

const OnboardingStepper = () => {
  const { t } = useTranslation();
  const { sizeExtraExtraLarge, fontSemiBold } = useTheme();
  const { pathname } = useLocation();
  const { data: customerData } = useGetDetailsQuery();
  const {
    skipOnboarding,
    isBenefitsSet,
    isEmployeesSet,
    isMoneyTransfered,
    isLoadInitiated
  } = customerData ?? {};
  const loadDone = !!(isMoneyTransfered || isLoadInitiated);
  const isHidden =
    !customerData ||
    skipOnboarding ||
    (isBenefitsSet && isEmployeesSet && loadDone);

  const isSelectBenefitActive = pathname.includes(`/${benefitGroupsUrlPrefix}`);
  const isAddEmployeesActive = pathname.includes(routerPaths.beneficiaries);
  const isLoadBalanceActive =
    pathname.includes(routerPaths.loadBenefit) ||
    pathname.includes(routerPaths.loadCompanyAccount);

  if (isHidden) return null;

  return (
    <Box
      display={'flex'}
      gap={5}
      alignItems="center"
      maxWidth={'1375px'}
      pt={5}
      margin={'0 auto'}
      pl={5}
      pr={5}
    >
      <Box fontSize={sizeExtraExtraLarge} fontWeight={fontSemiBold}>
        {t('components.benefit_onboarding.title')}
      </Box>
      <Box ml="auto" display="flex" gap={2}>
        <StepperStep
          stepNumber={1}
          label={t('components.benefit_onboarding.stepper.select_benefits')}
          isActive={isSelectBenefitActive}
          isDone={!!customerData?.isBenefitsSet}
        />
        <StepperStep
          stepNumber={2}
          label={t('components.benefit_onboarding.stepper.add_employees')}
          isActive={isAddEmployeesActive}
          isDone={!!customerData?.isEmployeesSet}
        />
        <StepperStep
          stepNumber={3}
          label={t('components.benefit_onboarding.stepper.load_balance')}
          isActive={isLoadBalanceActive}
          isDone={
            !!(customerData?.isMoneyTransfered || customerData?.isLoadInitiated)
          }
        />
      </Box>
    </Box>
  );
};

export default OnboardingStepper;
